import {
  Full,
  FullAG,
  Whole,
  WholeAG,
  OneThirdTwoThirds,
  Halves,
  HalvesRepeatable,
  Thirds,
  ThirdsRepeatable,
  TOCLayout
} from '~/layouts/Core'

// Content
import MassiveText from '~/components/Text/MassiveText/MassiveText'
import FeatureBannerV1 from '~/components/Content/Banners/Core/Feature/Variant1/FeatureBannerV1'
import FeatureBannerV2 from '~/components/Content/Banners/Core/Feature/Variant2/FeatureBannerV2'
import AvantFeatureBannerV1 from '~/components/Content/Banners/AvantGarde/Feature/Variant1/FeatureBannerV1'
import AvantFeatureBannerV2 from '~/components/Content/Banners/AvantGarde/Feature/Variant2/FeatureBannerV2'

// Media
import InteractiveImage from '~/components/Media/Core/Images/InteractiveImage/InteractiveImage'
import VideoPlaylist from '~/components/Media/Core/Video/VideoPlaylist/VideoPlaylist'

// Carousels
import FeatureBannerCarouselV1 from '~/components/Carousels/Core/FeatureBanner/Variant1/FeatureBannerCarousel'
import AvantFeatureBannerCarouselV1 from '~/components/Carousels/AvantGarde/FeatureBanner/Variant1/FeatureBannerCarousel'
import FeatureBannerCarouselV2 from '~/components/Carousels/Core/FeatureBanner/Variant2/FeatureBannerCarousel'
import AvantFeatureBannerCarouselV2 from '~/components/Carousels/AvantGarde/FeatureBanner/Variant2/FeatureBannerCarousel'
import FullScreenCarousel from '~/components/Carousels/Core/FullScreen/FullScreenCarousel'

const layoutMap = {
  layoutTableOfContents: TOCLayout,
  layoutFull: Full,
  layoutFullAvantGarde: FullAG,
  layoutWhole: Whole,
  layoutWholeAvantGarde: WholeAG,
  layoutOneThirdTwoThirds: OneThirdTwoThirds,
  layoutHalves: Halves,
  layoutHalvesRepeatable: HalvesRepeatable,
  layoutThirds: Thirds,
  layoutThirdsRepeatable: ThirdsRepeatable,

  textFeature: MassiveText,
  contentFeatureBannerV1: FeatureBannerV1,
  contentFeatureBannerV2: FeatureBannerV2,
  contentFeatureBannerV1AG: AvantFeatureBannerV1,
  contentFeatureBannerV2AG: AvantFeatureBannerV2,

  mediaInteractiveImage: InteractiveImage,
  mediaVideoPlaylist: VideoPlaylist,

  carouselFeatureBannerV1: FeatureBannerCarouselV1,
  carouselFeatureBannerV1AvantGarde: AvantFeatureBannerCarouselV1,
  carouselFeatureBannerV2: FeatureBannerCarouselV2,
  carouselFeatureBannerV2AvantGarde: AvantFeatureBannerCarouselV2,
  carouselFullScreen: FullScreenCarousel
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any

{
  /*
  CMS:
  - layoutWhole
  - layoutHalves
  - layoutThirds
  - layoutOneThirdTwoThirds
  */
}

export function loadLayout(cmsLayoutName: string) {
  // Uses the list of Layout names above and matches it to the correct Layout
  return layoutMap[cmsLayoutName]
}
